import { render, staticRenderFns } from "./COM_Menu.vue?vue&type=template&id=9ffed01e&scoped=true&"
import script from "./COM_Menu.vue?vue&type=script&lang=js&"
export * from "./COM_Menu.vue?vue&type=script&lang=js&"
import style0 from "./COM_Menu.vue?vue&type=style&index=0&id=9ffed01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffed01e",
  null
  
)

export default component.exports